const components = require.context('./', false, /\.vue$/);

const icons = {};

components.keys().forEach(filename => {
  const componentName = filename.replace(/^\.\//, '').replace(/\.vue$/, '');
  icons[componentName] = components(filename).default;
})

export default icons;

